import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsuranceTableComponent } from '../../../componentes/insurance-table/insurance-table.component';
import { ExportarComponent } from '../../../componentes/exportar/exportar.component';
import { CamposComponent } from '../../../componentes/campos/campos.component';
import { TableConfig } from '../../../interfaces/table-config.interface';
import {
  AgingProducerResponse,
  AgingProducerRequest,
} from '../../../interfaces/gestioncobros.interfaces';
import { ApiResponse } from '../../../interfaces/common.interfaces';
import { AuthService } from '../../../services/auth.service';
import { GestionCobrosService } from '../../../services/gestioncobros.service';
import { FormsModule } from '@angular/forms';
import {
  exportarExcel,
  exportarPDF,
  exportarTexto,
  exportarWord,
} from '../../../helpers/exportarAntiguedad';
import { HttpResponse } from '@angular/common/http';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-antiguedad',
  standalone: true,
  imports: [
    CommonModule,
    InsuranceTableComponent,
    ExportarComponent,
    CamposComponent,
    FormsModule,
  ],
  templateUrl: './antiguedad.component.html',
  styleUrl: './antiguedad.component.css',
})
export class AntiguedadComponent {
  insuranceData: AgingProducerResponse[] = [];
  mensajeNoData: string = 'Selecciona los campos que deseas buscar';
  errorStatus?: number;
  title: string = '';
  fecha1: Date = new Date();
  fecha2?: Date;
  //Configuración de la tabla
  tableConfig: TableConfig = {
    columns: [
      { key: 'policyNumber', label: 'Póliza', sortable: true, type: 'poliza' },
      { key: 'balance', label: 'Balance', sortable: true, type: 'currency' },
      {
        key: 'noVencido',
        label: 'No Vencido',
        sortable: true,
        type: 'currency',
      },
      { key: 'timeframe1', label: '1 a 30', sortable: true, type: 'currency' },
      { key: 'timeframe2', label: '31 a 60', sortable: true, type: 'currency' },
      { key: 'timeframe3', label: '61 a 90', sortable: true, type: 'currency' },
      {
        key: 'timeframe4',
        label: '91 a 120',
        sortable: true,
        type: 'currency',
      },
      {
        key: 'timeframe5',
        label: '121 a 180',
        sortable: true,
        type: 'currency',
      },
      {
        key: 'timeframe6',
        label: '181 a 270',
        sortable: true,
        type: 'currency',
      },
      {
        key: 'timeframe7',
        label: '271 a 365',
        sortable: true,
        type: 'currency',
      },
      {
        key: 'timeframe8',
        label: 'Mayor de 365',
        sortable: true,
        type: 'currency',
      },
    ],
    showTotals: true,
    itemsPerPage: 5,
  };


  opcionesSelectFilter = [
    { id: 'codigo', nombre: 'Código' },
    { id: 'cedula', nombre: 'Cédula' },
    { id: 'rnc', nombre: 'RNC' },
    { id: 'nombre', nombre: 'Nombre' },
  ];

  // Referencia al componente de la tabla
  @ViewChild(InsuranceTableComponent) tablaComponent!: InsuranceTableComponent;

  // Añadir nueva propiedad para controlar la empresa visible
  currentCompanyIndex: number = 0;
  showAllPolicies: boolean = false;
  inputCompanyPage: number = 1;

  constructor(
    private gestionCobrosService: GestionCobrosService,
    private authService: AuthService,
    private gAnalytics: GoogleAnalyticsService
  ) {
    this.title = 'Antigüedad';
  }

  // Filtro de datos
  onFilterChange(filter: any): void {
    this.currentCompanyIndex = 0;
    this.showAllPolicies = false;

    if (Object.keys(filter).length === 0) {
      this.insuranceData = [];
      this.mensajeNoData = 'Selecciona los campos que deseas buscar';
      this.errorStatus = undefined;
      return;
    }

    this.fecha1 = new Date();
    this.fecha2 = new Date();
    const request: AgingProducerRequest = {
      producerNumber: this.authService.getProducerNumber() || 0,
      ...(filter?.clientCode && { ClientCode: filter.clientCode }),
    };

    if (filter.clientCode) request.clientCode = filter.clientCode;

    this.gestionCobrosService.getAgingProducers(request).subscribe({
      next: (response: HttpResponse<ApiResponse<AgingProducerResponse[]>>) => {
        if (response.status === 200 && response.body?.data) {
          this.insuranceData = response.body.data;
          this.errorStatus = undefined;
        } else if (response.status === 204) {
          this.insuranceData = [];
          this.mensajeNoData = 'No hay datos disponibles para mostrar';
        }
      },
      error: (error) => {
        console.error('Error al obtener datos de antigüedad:', error);
        this.insuranceData = [];
        this.mensajeNoData = 'No se han podido obtener los datos de antigüedad';
      },
    });
  }
  // Exportar datos
  onExportar(formato: string): void {
    //Evento para trackear las exportaciones de archivos en Google Analytics
       this.gAnalytics.trackEvent('antiguedad_exportar',{
         page:'/antiguedad',
         format:formato
       })     
    if (!this.insuranceData.length) return;
    const usuario = this.authService.getProducerName();
    if (this.insuranceData.length > 1) {
      // Exportación con multiples clientes
      const sortedData = this.insuranceData.sort(
        (a, d) => parseInt(a.debtorId) - parseInt(d.debtorId)
      );
      const params = {
        data: sortedData,
        title: `Antigüedad de Saldos Pólizas por Intermediario - Plataforma Intermediario`,
        user: usuario!,
        tableConfig: this.tableConfig,
      };
      if (formato === 'pdf') exportarPDF(params);
      if (formato === 'word') exportarWord(params);
      if (formato === 'text') exportarTexto(params);
      if (formato === 'excel') exportarExcel(params);
    } else {
      // Exportación de un solo cliente
      if (this.tablaComponent) {
        const headerInfo = {
          titulo: 'Antigüedad',
          lob: this.getLobName(),
          slob: this.getSlobName(),
          fecha1: this.fecha1,
          fecha2: this.fecha2,
          tableConfig: this.tableConfig,
        };
        this.tablaComponent.exportarDatos(formato, headerInfo);
      }
    }
  }

  @ViewChild(CamposComponent) camposComponent!: CamposComponent;

  private getLobName(): string {
    const selectedLob = this.camposComponent?.lobs.find(
      (lob) => lob.lobId === Number(this.camposComponent?.selectedLob)
    );
    return selectedLob?.lobName || '';
  }

  private getSlobName(): string {
    const selectedSLob = this.camposComponent?.filteredSLobs.find(
      (slob) => slob.sLobId === Number(this.camposComponent?.selectedSLob)
    );
    return selectedSLob?.sLobName || '';
  }

  // Añadir métodos para navegación entre empresas
  nextCompany(): void {
    if (this.currentCompanyIndex < this.insuranceData.length - 1) {
      this.currentCompanyIndex++;
    }
  }

  previousCompany(): void {
    if (this.currentCompanyIndex > 0) {
      this.currentCompanyIndex--;
    }
  }

  // Método para obtener las empresas a mostrar
  getCompaniesToShow(): any[] {
    if (this.showAllPolicies) {
      return this.insuranceData;
    }
    return this.insuranceData.length > 0
      ? [this.insuranceData[this.currentCompanyIndex]]
      : [];
  }

  goToCompany(index: number): void {
    if (index >= 0 && index < this.insuranceData.length) {
      this.currentCompanyIndex = index;
    }
  }

  // Solo numeros
  onKeyPress(event: KeyboardEvent): void {
    if (!/^\d*$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
